import { createContext, useContext, useState, useEffect, useCallback } from "react";
import { fr } from "../i18n/fr";
import { en } from "../i18n/en";

const dicts = { fr, en };
const LanguageContext = createContext(null);

const resolve = (dict, path) =>
  path.split(".").reduce((o, k) => (o !== undefined && o !== null ? o[k] : undefined), dict);

export const LanguageProvider = ({ children }) => {
  const [lang, setLangState] = useState(() => {
    try {
      return localStorage.getItem("ghp-lang") || "fr";
    } catch {
      return "fr";
    }
  });

  const setLang = (l) => {
    try {
      localStorage.setItem("ghp-lang", l);
    } catch {}
    setLangState(l);
  };

  useEffect(() => {
    document.documentElement.lang = lang;
  }, [lang]);

  const t = useCallback(
    (path) => {
      const v = resolve(dicts[lang], path);
      if (v !== undefined) return v;
      const fallback = resolve(dicts.fr, path);
      return fallback !== undefined ? fallback : path;
    },
    [lang]
  );

  return (
    <LanguageContext.Provider value={{ lang, setLang, t }}>
      {children}
    </LanguageContext.Provider>
  );
};

export const useLanguage = () => useContext(LanguageContext);

export const useSEO = (title, description) => {
  useEffect(() => {
    if (title) document.title = title;
    if (description) {
      let meta = document.querySelector('meta[name="description"]');
      if (meta) meta.setAttribute("content", description);
    }
  }, [title, description]);
};
